import { render, staticRenderFns } from "./rule-list.vue?vue&type=template&id=7816a1c2&"
import script from "./rule-list.vue?vue&type=script&lang=js&"
export * from "./rule-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports